import { AgentFilterSelector } from "@/agents/navigation"
import {
  FEATURE_FLAGS,
  usePostHydrationFeatureFlagValue,
} from "@/feature-flags"
import { WorkspaceSwitcher } from "@/workspaces"

interface WorkspaceSidebarSelectorProps {
  className?: string
}

/**
 * Keeps the legacy agent selector available until workspaces has positively
 * resolved on. Unlike redirect fallbacks, this control is safe to show while
 * PostHog is still loading.
 */
export function WorkspaceSidebarSelector({
  className,
}: WorkspaceSidebarSelectorProps) {
  const workspaceFlagValue = usePostHydrationFeatureFlagValue(
    FEATURE_FLAGS.WORKSPACES,
  )

  if (workspaceFlagValue === true) {
    return <WorkspaceSwitcher className={className} />
  }

  return <AgentFilterSelector className={className} />
}
